import { jsx as r, jsxs as l } from "react/jsx-runtime";
import { forwardRef as q, useRef as D, useState as y, useImperativeHandle as I, useLayoutEffect as K, useMemo as M, useCallback as U, createContext as V, useContext as G, useEffect as Y } from "react";
import { VList as J } from "virtua";
import { DateTime as H } from "luxon";
import B from "classnames";
import { saveFileAs as Q, useDebounce as X } from "@electra-one/utils";
import { spacing as Z, theme as O, Button as k, SwitchField as ee, InputField as te, SelectField as x } from "@electra-one/components";
import { ChevronUp as re, ChevronDown as ne } from "react-feather";
import "@electra-one/midi";
var le = "h4okm20";
const ce = (e, n, t) => {
  if (n < 0 || n !== 0 && n > e.length || t.length === 0)
    return e;
  const c = e.slice(0, n), o = e.slice(n), i = c.at(-1), s = o.at(0);
  return i !== void 0 && !/\s/.test(i) && (t = ` ${t}`), s !== void 0 && !/\s/.test(s) && (t += " "), `${c}${t}${o}`;
}, ae = q(
  ({ placeholder: e, onExecute: n }, t) => {
    const c = D(null), [o, i] = y(""), s = (u) => {
      if (u.code === "Enter" && u.ctrlKey) {
        u.preventDefault();
        const d = u.target.value;
        d.length > 0 && (n == null || n(d));
      }
    };
    return I(
      t,
      () => ({
        appendText: (u) => {
          if (c.current !== null) {
            const d = c.current.selectionStart;
            i((p) => ce(p, d, u));
          }
        }
      }),
      []
    ), /* @__PURE__ */ r(
      "textarea",
      {
        ref: c,
        className: le,
        value: o,
        onChange: (u) => i(u.target.value),
        placeholder: e,
        onKeyDown: s
      }
    );
  }
);
var oe = "_13wg7oi0", ie = "_1tu1d6t0";
const se = ({
  items: e,
  itemRenderer: n,
  autoScroll: t,
  onAutoScrollChange: c
}) => {
  const o = D(null);
  K(() => {
    t && o.current !== null && e.length > 0 && o.current.scrollToIndex(e.length - 1, {
      align: "end"
    });
  }, [e.length, t]);
  const i = M(
    () => e.map((u, d) => /* @__PURE__ */ r(n, { index: d, item: u }, `terminal-row-${d}`)),
    [n, e]
  ), s = U(
    (u) => {
      if (o.current === null || o.current.viewportSize === 0)
        return null;
      u - o.current.scrollSize + o.current.viewportSize >= -1.5 ? t || c(!0) : t && c(!1);
    },
    [t, c]
  );
  return /* @__PURE__ */ r("div", { className: ie, children: /* @__PURE__ */ r(J, { ref: o, overscan: 30, onScroll: s, children: i }) });
};
var de = "zg8ynx0";
const h = ({
  className: e,
  children: n
}) => /* @__PURE__ */ r("span", { className: B(de, e), children: n });
var ue = "_16ckmj60", he = "_16ckmj61", pe = "_16ckmj62";
const me = ({
  item: e
}) => {
  const n = H.fromMillis(e.timestamp).toFormat("HH:mm:ss.SSS");
  return /* @__PURE__ */ l("div", { className: ue, children: [
    /* @__PURE__ */ l("span", { className: he, children: [
      /* @__PURE__ */ r(h, { children: n }),
      e.lua && /* @__PURE__ */ r(h, { className: pe, children: "lua" })
    ] }),
    /* @__PURE__ */ r("span", { children: e.data })
  ] });
}, N = ({ channel: e }) => /* @__PURE__ */ l(h, { children: [
  "ch #",
  e + 1
] }), g = V(null);
g.displayName = "MidiTerminalContext";
const ve = ({
  terminalRef: e,
  children: n
}) => {
  const [t, c] = y([]), o = M(
    () => ({
      expandedAt: t,
      expandAt: (i) => c((s) => [...s, i]),
      collapseAt: (i) => c((s) => s.filter((u) => u !== i)),
      appendToScratchpad: (i) => {
        e.current !== null && e.current.appendToScratchpad(i);
      },
      exportMessage: (i) => {
        const s = Uint8Array.from(i.rawData), u = new Blob([s], { type: "application/octet-stream" });
        Q(u, "message.syx");
      }
    }),
    [t, e]
  );
  return /* @__PURE__ */ r(g.Provider, { value: o, children: n });
}, $ = () => {
  const e = G(g);
  if (e === null)
    throw new Error(`${g.displayName} is null`);
  return e;
}, L = (e) => {
  const { expandedAt: n } = $();
  return M(() => n.includes(e), [n, e]);
}, fe = () => {
  const { expandAt: e } = $();
  return e;
}, ye = () => {
  const { collapseAt: e } = $();
  return e;
}, Se = () => {
  const { appendToScratchpad: e } = $();
  return e;
}, be = () => {
  const { exportMessage: e } = $();
  return e;
}, v = (e) => e.toString(16).padStart(2, "0"), P = (e) => e > 32 ? String.fromCharCode(e) : ".";
var Ne = "m378vq0", we = "m378vq1";
function* xe(e, n) {
  for (let t = 0; t < e.length; t += n)
    yield e.slice(t, t + n);
}
const R = ({
  keyPrefix: e,
  tokenLength: n,
  columnCount: t,
  columnSize: c,
  data: o,
  formatter: i,
  truncate: s
}) => {
  const u = M(() => Array.from(
    xe(
      s !== void 0 ? o.slice(0, s) : o,
      c
    )
  ).map((d) => d.map(i).join(" ")), [c, o, i, s]);
  return /* @__PURE__ */ r(
    "div",
    {
      className: Ne,
      style: {
        width: `calc(${t * (n * c + c - 1)}ch + ${Z(O.oneUnit, 2)})`
      },
      children: u.map((d, p) => /* @__PURE__ */ r(
        "span",
        {
          className: we,
          children: d
        },
        `${e !== void 0 ? `${e}-` : ""}column-${p}-chunk-${d}`
      ))
    }
  );
};
var m = "yiq4s40";
const j = ({ message: e }) => /* @__PURE__ */ l(h, { children: [
  "note ",
  "status" in e && e.status,
  " ",
  e.note,
  e.octave
] }), ke = ({ bend: e }) => e === 0 ? /* @__PURE__ */ r(h, { children: "bend 0%" }) : e > 0 ? /* @__PURE__ */ l(h, { children: [
  "bend +",
  (e / 8191 * 100).toFixed(0),
  "% (",
  e,
  ")"
] }) : /* @__PURE__ */ l(h, { children: [
  "bend ",
  (e / 8192 * 100).toFixed(0),
  "% (",
  e,
  ")"
] }), $e = {
  clock: "midi beat clock",
  start: "start playback",
  cont: "continue playback",
  stop: "stop playback",
  as: "active sensing",
  rst: "reset",
  tun: "tune request",
  tcqf: "midi time code quarter frame",
  invalid: "invalid midi message"
}, Te = ({
  index: e,
  expanded: n,
  message: t
}) => {
  switch (t.status) {
    case "on":
    case "off":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ r(j, { message: t }),
        /* @__PURE__ */ l(h, { children: [
          "velocity ",
          t.velocity,
          " (",
          v(t.velocity),
          "h)"
        ] })
      ] });
    case "pp":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ r(j, { message: t }),
        /* @__PURE__ */ l(h, { children: [
          "pressure ",
          t.pressure,
          " (",
          v(t.pressure),
          "h)"
        ] })
      ] });
    case "cc":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ l(h, { children: [
          "control ",
          t.controller,
          " (",
          v(t.controller),
          "h)"
        ] }),
        /* @__PURE__ */ l(h, { children: [
          "value ",
          t.value,
          " (",
          v(t.value),
          "h)"
        ] })
      ] });
    case "pc":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ l(h, { children: [
          "program ",
          t.program,
          " (",
          v(t.program),
          "h)"
        ] })
      ] });
    case "cp":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ l(h, { children: [
          "pressure ",
          t.pressure,
          " (",
          v(t.pressure),
          "h)"
        ] })
      ] });
    case "pb":
      return /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(N, { channel: t.channel }),
        /* @__PURE__ */ r(ke, { bend: t.bend })
      ] });
    case "spp":
      return /* @__PURE__ */ r("span", { className: m, children: /* @__PURE__ */ l(h, { children: [
        "position ",
        t.position,
        " (",
        v(t.position),
        "h)"
      ] }) });
    case "ss":
      return /* @__PURE__ */ r("span", { className: m, children: /* @__PURE__ */ l(h, { children: [
        "song ",
        t.song,
        " (",
        v(t.song),
        "h)"
      ] }) });
    case "syx":
      return n ? /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(h, { children: "sysex" }),
        /* @__PURE__ */ r(
          R,
          {
            tokenLength: 1,
            columnCount: 2,
            columnSize: 5,
            data: t.rawData,
            formatter: P
          }
        ),
        /* @__PURE__ */ l(h, { children: [
          t.rawData.length,
          " bytes"
        ] })
      ] }) : /* @__PURE__ */ l("span", { className: m, children: [
        /* @__PURE__ */ r(h, { children: "sysex" }),
        /* @__PURE__ */ r(
          R,
          {
            keyPrefix: e,
            tokenLength: 1,
            columnCount: 2,
            columnSize: 5,
            data: t.rawData,
            truncate: 10,
            formatter: P
          }
        ),
        /* @__PURE__ */ l(h, { children: [
          t.rawData.length,
          " bytes"
        ] })
      ] });
  }
  const c = $e[t.status];
  return c !== void 0 ? /* @__PURE__ */ r("span", { className: m, children: /* @__PURE__ */ r(h, { children: c }) }) : null;
};
var Ae = "_13e9dvp0";
const Ee = ({
  index: e,
  isSysEx: n,
  onCopyToScratchpad: t,
  onExport: c
}) => {
  const o = L(e), i = fe(), s = ye();
  return /* @__PURE__ */ l("div", { className: Ae, children: [
    /* @__PURE__ */ r(k, { compact: !0, onClick: t, children: "Copy to Scratchpad" }),
    /* @__PURE__ */ r(k, { compact: !0, onClick: c, children: "Export" }),
    /* @__PURE__ */ r(
      k,
      {
        style: { visibility: n ? "visible" : "hidden" },
        compact: !0,
        onClick: () => o ? s(e) : i(e),
        children: o ? /* @__PURE__ */ r(re, {}) : /* @__PURE__ */ r(ne, {})
      }
    )
  ] });
};
var _e = "_1uvugdc0", Ce = "_1uvugdc1", ge = "_1uvugdc2", De = "_1uvugdc3", Me = "_1uvugdc4", Fe = "_1uvugdc5", Re = "_1uvugdc6";
const Be = ({
  index: e,
  item: n
}) => {
  const t = L(e), c = H.fromMillis(n.timestamp).toFormat(
    "HH:mm:ss.SSS"
  ), o = Se(), i = be();
  return /* @__PURE__ */ l("div", { className: B([_e, e % 2 === 0 && Ce]), children: [
    /* @__PURE__ */ l("span", { className: ge, children: [
      /* @__PURE__ */ r(h, { children: c }),
      /* @__PURE__ */ r(h, { className: n.direction === "in" ? De : Me, children: n.direction }),
      n.portCode !== null && /* @__PURE__ */ r(h, { className: Fe, children: n.portCode }),
      /* @__PURE__ */ r(h, { className: Re, children: n.status })
    ] }),
    /* @__PURE__ */ r(
      R,
      {
        keyPrefix: e,
        tokenLength: 2,
        columnCount: 2,
        columnSize: 5,
        data: n.rawData,
        formatter: v,
        truncate: t ? void 0 : 10
      }
    ),
    /* @__PURE__ */ r(Te, { index: e, expanded: t, message: n }),
    /* @__PURE__ */ r(
      Ee,
      {
        index: e,
        isSysEx: n.status === "syx",
        onCopyToScratchpad: () => o(
          n.rawData.map((s) => `${s.toString(16)}h`).join(" ")
        ),
        onExport: () => i(n)
      }
    )
  ] });
};
var Pe = "_1rswdre0", je = "_1rswdre1";
const W = ({
  className: e,
  children: n,
  autoScroll: t,
  onClear: c,
  onExport: o,
  onAutoScrollChange: i
}) => /* @__PURE__ */ l("div", { className: B(Pe, e), children: [
  n,
  /* @__PURE__ */ l("div", { className: je, children: [
    /* @__PURE__ */ r(k, { onClick: c, children: "Clear" }),
    /* @__PURE__ */ r(
      ee,
      {
        id: "debug-terminal-auto-scroll-switch",
        label: "Auto scroll",
        checked: t,
        onChange: (s) => i(s.target.checked)
      }
    ),
    /* @__PURE__ */ r(k, { onClick: o, children: "Export" })
  ] })
] }), z = q(
  ({
    children: e,
    items: n,
    itemRenderer: t,
    scratchpadPlaceholder: c,
    autoScroll: o,
    onAutoScrollChange: i,
    onExecute: s
  }, u) => {
    const d = D(null);
    return I(
      u,
      () => ({
        appendToScratchpad: (p) => {
          d.current !== null && d.current.appendText(p);
        }
      }),
      []
    ), /* @__PURE__ */ l("div", { className: oe, children: [
      e,
      /* @__PURE__ */ r(
        se,
        {
          items: n,
          itemRenderer: t,
          autoScroll: o,
          onAutoScrollChange: i
        }
      ),
      /* @__PURE__ */ r(
        ae,
        {
          ref: d,
          placeholder: c,
          onExecute: s
        }
      )
    ] });
  }
);
var qe = "_18k8oqo0";
const Qe = ({
  entries: e,
  onClearAll: n,
  onExportAll: t,
  onExecuteLua: c,
  onLogLevelChange: o
}) => {
  const [i, s] = y([]), [u, d] = y(""), [p, T] = y(""), [A, w] = y("disabled"), [S, b] = y(!0), E = X(d, 1e3);
  return Y(() => {
    s(e.filter((f) => f.data.includes(u)));
  }, [e, u]), /* @__PURE__ */ r(
    z,
    {
      items: i,
      itemRenderer: me,
      scratchpadPlaceholder: 'Type in Lua commands, eg. print ("hello world")',
      autoScroll: S,
      onAutoScrollChange: b,
      onExecute: c,
      children: /* @__PURE__ */ r(
        W,
        {
          autoScroll: S,
          onAutoScrollChange: b,
          onClear: () => {
            s([]), n == null || n();
          },
          onExport: t,
          children: /* @__PURE__ */ l("div", { className: qe, children: [
            /* @__PURE__ */ r(
              te,
              {
                id: "lua-console-filter-input",
                label: "Filter",
                value: p,
                onChange: (f) => {
                  E(f.target.value), T(f.target.value);
                }
              }
            ),
            /* @__PURE__ */ l(
              x,
              {
                id: "lua-console-log-level",
                label: "Log level",
                value: A,
                onChange: (f) => {
                  w(f.target.value), o == null || o(f.target.value);
                },
                children: [
                  /* @__PURE__ */ r("option", { value: "disabled", children: "Disabled" }),
                  /* @__PURE__ */ r("option", { value: "critical", children: "Critical" }),
                  /* @__PURE__ */ r("option", { value: "warning", children: "Warning" }),
                  /* @__PURE__ */ r("option", { value: "info", children: "Info" }),
                  /* @__PURE__ */ r("option", { value: "trace", children: "Trace" })
                ]
              }
            )
          ] })
        }
      )
    }
  );
}, Ie = (e) => e.endsWith("h") ? Number.parseInt(e.substring(0, e.length - 1), 16) : e.startsWith("0b") ? Number.parseInt(e.substring(2), 2) : Number.parseInt(e);
var He = "_1oktkp80";
const Xe = ({
  messages: e,
  inputs: n,
  output: t,
  inputPorts: c,
  outputPorts: o,
  onClearAll: i,
  onExportAll: s,
  onSendMidi: u,
  onInputChange: d,
  onOutputChange: p
}) => {
  const [T, A] = y(!0), w = n[1], S = n[2], b = n[3], E = D(null);
  return /* @__PURE__ */ r(ve, { terminalRef: E, children: /* @__PURE__ */ r(
    z,
    {
      ref: E,
      items: e,
      itemRenderer: Be,
      scratchpadPlaceholder: "Type in console commands or raw MIDI messages",
      autoScroll: T,
      onAutoScrollChange: A,
      onExecute: (a) => {
        try {
          const F = a.toLocaleLowerCase().split(/\s/).filter((_) => _.length > 0).map((_) => {
            const C = Ie(_);
            return console.log(_, C), isNaN(C) || C < 0 ? 0 : C;
          });
          u == null || u(F);
        } catch (F) {
          console.error(F);
        }
      },
      children: /* @__PURE__ */ r(
        W,
        {
          autoScroll: T,
          onAutoScrollChange: A,
          onClear: i,
          onExport: s,
          children: /* @__PURE__ */ l("div", { className: He, children: [
            /* @__PURE__ */ l(
              x,
              {
                id: "midi-console-input1-select",
                label: "Input 1",
                value: w ?? "none",
                onChange: (a) => d == null ? void 0 : d(
                  "1",
                  a.target.value === "none" ? null : a.target.value
                ),
                children: [
                  /* @__PURE__ */ r("option", { value: "none" }),
                  c.map((a) => /* @__PURE__ */ r(
                    "option",
                    {
                      value: a.id,
                      disabled: a.id === S || a.id === b,
                      children: a.name
                    },
                    `midi-console-input-port-1-${a.id}`
                  ))
                ]
              }
            ),
            /* @__PURE__ */ l(
              x,
              {
                id: "midi-console-input2-select",
                label: "Input 2",
                value: S ?? "none",
                onChange: (a) => d == null ? void 0 : d(
                  "2",
                  a.target.value === "none" ? null : a.target.value
                ),
                children: [
                  /* @__PURE__ */ r("option", { value: "none" }),
                  c.map((a) => /* @__PURE__ */ r(
                    "option",
                    {
                      value: a.id,
                      disabled: a.id === w || a.id === b,
                      children: a.name
                    },
                    `midi-console-input-port-2-${a.id}`
                  ))
                ]
              }
            ),
            /* @__PURE__ */ l(
              x,
              {
                id: "midi-console-input3-select",
                label: "Input 3",
                value: b ?? "none",
                onChange: (a) => d == null ? void 0 : d(
                  "3",
                  a.target.value === "none" ? null : a.target.value
                ),
                children: [
                  /* @__PURE__ */ r("option", { value: "none" }),
                  c.map((a) => /* @__PURE__ */ r(
                    "option",
                    {
                      value: a.id,
                      disabled: a.id === w || a.id === S,
                      children: a.name
                    },
                    `midi-console-input-port-3-${a.id}`
                  ))
                ]
              }
            ),
            /* @__PURE__ */ l(
              x,
              {
                id: "midi-console-output-select",
                label: "Output",
                value: t ?? "none",
                onChange: (a) => p == null ? void 0 : p(
                  a.target.value === "none" ? null : a.target.value
                ),
                children: [
                  /* @__PURE__ */ r("option", { value: "none" }),
                  o.map((a) => /* @__PURE__ */ r(
                    "option",
                    {
                      value: a.id,
                      children: a.name
                    },
                    `midi-console-output-port-${a.id}`
                  ))
                ]
              }
            )
          ] })
        }
      )
    }
  ) });
};
export {
  Qe as LuaConsole,
  Xe as MidiConsole,
  v as formatAs8BitHex,
  P as formatAsAscii
};
//# sourceMappingURL=index.js.map
